import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import PageHeader from '../components/ui/PageHeader';
import { FadeIn } from '../components/ui/AnimatedSection';
import { useTranslation } from 'react-i18next';

export default function Cgv() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col font-sans text-black-deep bg-cream-100">
      <Navbar />
      
      <main className="flex-grow">
        <PageHeader 
          title={t('cgvPage.headerTitle')} 
          subtitle={t('cgvPage.headerSubtitle')}
          imagePath="/assets/luxury_gloves.webp" 
        />

        <section className="py-24 bg-white relative">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <FadeIn>
              <div className="prose prose-lg prose-gold max-w-none text-gray-700 font-light">
                <p className="text-sm text-gray-400 mb-12 uppercase tracking-widest font-bold">
                  {t('cgvPage.lastUpdate', { date: new Date().toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' }) })}
                </p>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('cgvPage.art1Title')}</h2>
                <p dangerouslySetInnerHTML={{ __html: t('cgvPage.art1P1') }}></p>
                <p>{t('cgvPage.art1P2')}</p>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('cgvPage.art2Title')}</h2>
                <h3 className="text-xl font-serif text-black-deep mt-8 mb-4">{t('cgvPage.art2_1Title')}</h3>
                <p>{t('cgvPage.art2_1P1')}</p>
                <h3 className="text-xl font-serif text-black-deep mt-8 mb-4">{t('cgvPage.art2_2Title')}</h3>
                <p>{t('cgvPage.art2_2P1')}</p>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('cgvPage.art3Title')}</h2>
                <h3 className="text-xl font-serif text-black-deep mt-8 mb-4">{t('cgvPage.art3_1Title')}</h3>
                <p>{t('cgvPage.art3_1P1')}</p>
                <h3 className="text-xl font-serif text-black-deep mt-8 mb-4">{t('cgvPage.art3_2Title')}</h3>
                <p>{t('cgvPage.art3_2P1')}</p>
                <ul className="list-disc pl-5 space-y-2 mt-4">
                  <li>{t('cgvPage.art3_2L1')}</li>
                  <li>{t('cgvPage.art3_2L2')}</li>
                  <li>{t('cgvPage.art3_2L3')}</li>
                  <li>{t('cgvPage.art3_2L4')}</li>
                </ul>
                <p className="mt-4 text-xs italic text-gray-400">{t('cgvPage.art3_2Note')}</p>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('cgvPage.art4Title')}</h2>
                <p>{t('cgvPage.art4P1')}</p>
                <p>{t('cgvPage.art4P2')}</p>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('cgvPage.art5Title')}</h2>
                <h3 className="text-xl font-serif text-black-deep mt-8 mb-4">{t('cgvPage.art5_1Title')}</h3>
                <p dangerouslySetInnerHTML={{ __html: t('cgvPage.art5_1P1') }}></p>
                <h3 className="text-xl font-serif text-black-deep mt-8 mb-4">{t('cgvPage.art5_2Title')}</h3>
                <p>{t('cgvPage.art5_2P1')}</p>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('cgvPage.art6Title')}</h2>
                <p>{t('cgvPage.art6P1')}</p>
                <p>{t('cgvPage.art6P2')}</p>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('cgvPage.art7Title')}</h2>
                <p>{t('cgvPage.art7P1')}</p>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('cgvPage.art8Title')}</h2>
                <p>{t('cgvPage.art8P1')}</p>

                <h2 className="text-3xl font-serif text-black-deep mb-6 mt-16 border-b border-gray-100 pb-4">{t('cgvPage.art9Title')}</h2>
                <p>{t('cgvPage.art9P1')}</p>

              </div>
            </FadeIn>
          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
}
